export default "__VITE_ASSET__BvAF1Tjv__"